import React, { useEffect, useState, useCallback, useRef } from "react";
import { Modal, Tooltip } from "antd";
import "./matchingRecordsTable.scss";
import { CheckOutlined } from "@ant-design/icons";
import TableWithStaticPagination from "../../table/tableWithStaticPagination";
import { isEmpty, map, sortBy } from "lodash";
import WellBeEMPIService from "@services/empiService.service";
import ExtraDetailsOfUser from "../detailsOfUser/detailsOfUser";
import Icon from "@assets/icon_config";
import { formatDisplayDate } from "@utils/helpers";
import { NoDataFound } from "@pages/member-details/care-coordination/components/care-plan-report/programPage/programPage";

const MatchedRecords = (props: {
  columnsNeedToShowInTable: any;
  columnsNeedToShowInPopUp: any;
  handleMergeClick: (arg0: { uniqueId: any; targetId: any }) => void;
  record: { member_unique_id: any; rec_group_id: any; member_first_name: any; member_last_name: any };
  payer: any;
  icon?: any;
  isLoading: boolean | undefined;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const columnsList: any = useRef(null);

  useEffect(() => {
    let _columns = map(props.columnsNeedToShowInTable, (item) => {
      if (item.key === "pred_empi_confdc_score") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          // sorter: (a: { [x: string]: number }, b: { [x: string]: number }) => a[item.dataIndex] - b[item.dataIndex],
          render: (value: any, record: any) => {
            return !record.isOriginal ? (
              <div className="ui-empi-matching-records__table__empi-match-column">
                <div className="ui-empi-matching-records__table__empi-match-column__value">{value}%</div>
                {record?.pred_empi}
              </div>
            ) : (
              <Icon name="lesserThanGreaterThanArrow" />
            );
          },
        };
      }
      if (item.key === "action_desc") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          render: (value: any, record: any) => {
            return (
              <div className="ui-empi-matching-records__table__action-column">
                <ExtraDetailsOfUser record={record} columnListForPopUp={props.columnsNeedToShowInPopUp} />
                {!record.isOriginal && (
                  <Tooltip title={"Merge Into this Patient"}>
                    <CheckOutlined
                      onClick={() => {
                        setLoading(true);
                        props.handleMergeClick({ uniqueId: props?.record?.member_unique_id, targetId: record?.member_unique_id });
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            );
          },
        };
      } else if (item.key === "member_dob") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          // sorter: true,
          render: (value: any) => formatDisplayDate(value, "createDateFormat", "defaultDateFormat"),
        };
      } else {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          // sorter: (a: { [x: string]: any }, b: { [x: string]: any }) => a[item.dataIndex].localeCompare(b[item.dataIndex]),
          render: (value: any) => value || "--",
        };
      }
    });

    _columns = sortBy(_columns, (item: any) => {
      return item.order;
    });

    columnsList.current = _columns;
  }, [props]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchData = useCallback(async () => {
    console.log("ExpandableTable.fetchData");
    setIsModalOpen(true);
    setLoading(true);

    WellBeEMPIService.fetchExistingMatchingRecords({ payerName: props.payer, groupId: props.record.rec_group_id }).subscribe({
      next: (response: { data: { data: { records: any } } }) => {
        const _data = response?.data?.data?.records;
        setData(_data);
        setLoading(false);
      },
      error: (e) => {
        console.log(e);
        setLoading(false);
      },
    });
  }, [props.payer, props.record.rec_group_id]);

  return (
    <>
      <Tooltip title="See Matching Records">
        <span className="action-icon" onClick={() => fetchData()}>
          {props.icon || <Icon name="listDropDown" />}
        </span>
      </Tooltip>

      <Modal width="auto" centered title="Matching EMPIs" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[]}>
        <div className="ui-empi-matching-records">
          <div className="ui-empi-matching-records__name">{`${props.record.member_first_name} ${props.record.member_last_name}`}</div>
          <TableWithStaticPagination loading={loading} className="ui-empi-matching-records__table" columns={columnsList.current} data={[{ ...props.record, isOriginal: true }, ...data]} />
          {isEmpty(data) && !loading ? <NoDataFound /> : null}
        </div>
      </Modal>
    </>
  );
};

export default MatchedRecords;
